import React, { Component, Fragment } from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { connect } from 'react-redux';
import Header from './Header';
import Details from './Details';

const QUERY = gql`
query commissionTransfer($operatorId: String, $transferId: String){
  commissionTransfer(operatorId: $operatorId, transferId: $transferId){
    id
      amount
      createdAt
      adjustmentAmount
    	adjustmentDescription
    	transfer{
          status
          destinationBankAccount{
            name
            cpfCnpj
            bankCode
            agency
            agencyDigit
            account
            accountDigit
            accountType
          }
      }
      entity {
        portalUser {
          user {
            name
          }
        }
        operator {
          title
        }
        establishment {
          title
        }
      }
  }
}
`;

class TransferDetails extends Component {
    render() {
        const { operatorId } = this.props;
        const transferId = this.props.match.params.id;
        return (
            <Query query={QUERY} variables={{ operatorId, transferId }}>
                {({ loading, error, data }) => {
                    if (loading) return 'Loading...';
                    if (error) {
                        return (
                            <div className="rounded-0 alert alert-warning m-0">
                                Não foi possível carregar os detalhes da transferência.
                            </div>
                        );
                    }
                    console.log(data)
                    const { commissionTransfer } = data
                    const { transfer} = commissionTransfer
                    const { status, destinationBankAccount } = transfer
                    return (
                        <Fragment>
                            <Header/>
                            <div className="container-fluid mt--6">
                              <Details
                                status={status}
                                destinationBankAccount={destinationBankAccount}
                                transfer={commissionTransfer}
                              />
                            </div>

                        </Fragment>
                    );
                }}
            </Query>
        );
    }
}

const mapStateToProps = (state) => ({
    operatorId: state.session.operatorId
});

export default connect(mapStateToProps)(TransferDetails);



// WEBPACK FOOTER //
// ./src/components/Pages/CommissionsTransfers/Details/index.js